export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Hailuo 2.3 视频生成器 - MiniMax AI视频创作平台',
        pageDescription:
            '体验 Hailuo 2.3 视频生成器，在复杂肢体动作、多元风格化、人物微表情以及物体运动指令响应方面实现了关键性突破，专为电商广告等商业场景优化。免费试用下一代AI视频创作工具。',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI视频生成器, 电商视频, 产品展示, 动态视频, 免费AI视频, 微鲤AI',

        // 生成器部分
        generatorTitle: 'Hailuo 2.3 视频生成器',
        generatorDescription:
            'MiniMax Hailuo 2.3 是基于 Hailuo 02 模型的革命性升级，在<span class="text-text-active">复杂肢体动作、多元风格化、人物微表情</span>以及<span class="text-text-active">物体运动指令响应</span>方面实现了关键性突破，尤其擅长解决电商广告等商业场景中的产品动态展示难题，显著提升视频内容的质量与产出效率。立即<span class="text-text-active">免费试用</span>，体验下一代AI视频创作的强大魅力！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo 2.3 核心功能',

        // 更精准的动态控制与真实画面
        dynamicControlTitle: '更精准的动态控制与真实画面',
        dynamicControlDescription:
            '模型对物理表现与指令遵循能力显著增强，可生成更加复杂、流畅且自然的人物肢体动作。在不同的大动态运镜下，光线、明暗过渡和色调都能实现近乎实拍的视觉效果，画面稳定性和精确度更高。',

        // 更强大的多元风格化支持
        styleSupportTitle: '更强大的多元风格化支持',
        styleSupportDescription:
            '对动漫、插画、水墨、游戏CG等特殊画风的支持效果更佳。无论是通用模型还是特定风格，输出效果都更稳定、更生动，充分释放您的艺术创作潜力。',

        // 更细腻的人物微表情演绎
        microExpressionTitle: '更细腻的人物微表情演绎',
        microExpressionDescription:
            '在Hailuo 2.3中，真人面部表演和微表情变化更加自然细腻。通过AI捕捉细微的表情变化，打造更具感染力和故事性的角色表演，让角色物栩栩如生。',

        // 更出色的物体运动指令响应
        objectMotionTitle: '更出色的物体运动指令响应',
        objectMotionDescription:
            '专为电商广告场景优化，对产品的运动指令响应更加出色。可高效解决产品移动、展示等难题，有效提升电商视频广告的"抽卡"成功率和专业度。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择Hailuo 2.3模型',
        step1Description:
            '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo 2.3"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: 'Hailuo 2.3 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Hailuo 2.3 视频模型的 X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他视频模型',
        hailuo02Title: 'Hailuo 02 AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',
        wanTitle: 'Wan AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Hailuo 2.3 相比之前的版本有哪些主要提升？',
        faq1Answer:
            'Hailuo 2.3 主要在四大方面实现提升：肢体动作更复杂流畅、风格化支持更广更佳、人物微表情更细腻自然、对物体运动指令的响应更精准。这些提升共同使得生成的视频动态表现力更强，画面更真实稳定。',

        faq2Question: 'Hailuo 2.3 适合用来制作什么类型的视频？',
        faq2Answer:
            '它非常适合制作短视频内容、电商产品广告、动漫创作、游戏CG、艺术风格化短片等。特别是在需要精确控制产品运动或人物表情的电商和内容创作领域，表现出色。',

        faq3Question: '什么是 Hailuo 2.3 Fast 模型？它和标准版有什么区别？',
        faq3Answer:
            'Hailuo 2.3 Fast 是一个优化了生成速度的模型版本，定价更低，速度更快，专为需要大批量生成视频、对成本敏感的用户设计。标准版则在极限画质和细节上可能更优。用户可根据项目需求灵活选择。',

        faq4Question: '如何使用 Hailuo 2.3 模型？是否需要下载？',
        faq4Answer:
            '无需下载。您可以直接访问海螺AI官网，在网页端或APP中即可选择使用Hailuo 2.3模型进行视频生成。开放平台开发者也可通过调用API接口集成该能力。',

        faq5Question: '新用户是否有免费试用的机会？',
        faq5Answer:
            '是的！在模型发布期间，我们每日为所有用户提供免费试用额度，您可以直接访问官网注册账号，无需付费即可立即体验Hailuo 2.3的强大功能。',

        faq6Question: '什么是 Media Agent？它和 Hailuo 2.3 有什么关系？',
        faq6Answer:
            'Media Agent（媒体智能体）是一个支持全模态创作的AI工具，它可以智能调用Hailuo 2.3等模型。您只需输入想法，它即可实现"一键成片"，自动化完成视频剪辑，极大简化创作流程。它们是相辅相成的关系。',

        faq7Question: 'Hailuo 2.3 的视频生成成本高吗？',
        faq7Answer:
            'Hailuo 2.3 以"业界最优性价比"为目标，在提升效果的同时保持了原有价格。此外，通过选择Hailuo 2.3 Fast模型，还能进一步大幅降低批量创作的成本。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle:
            'Hailuo 2.3 動画ジェネレーター - MiniMax AI動画作成プラットフォーム',
        pageDescription:
            'Hailuo 2.3 動画ジェネレーターを体験。複雑な身体の動き、多様なスタイル化、顔の微表情、物体の動作指令への応答において画期的な成果を実現。Eコマース広告シナリオに最適化。次世代AI動画作成ツールを無料で試す。',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI動画ジェネレーター, Eコマース動画, 製品ショーケース, ダイナミック動画, 無料AI動画, 微鲤AI',

        // ジェネレーター部分
        generatorTitle: 'Hailuo 2.3 動画ジェネレーター',
        generatorDescription:
            'MiniMax Hailuo 2.3は、Hailuo 02モデルをベースにした革新的なアップグレードで、<span class="text-text-active">複雑な身体の動き、多様なスタイル化、顔の微表情</span>、および<span class="text-text-active">物体の動作指令への応答</span>において重要なブレークスルーを達成しました。Eコマース広告などの商業シナリオにおける製品の動的表示の課題を解決することに優れ、動画コンテンツの品質と生産効率を大幅に向上させます。<span class="text-text-active">今すぐ無料で試して</span>、次世代AI動画作成の強力な魅力を体験してください！',

        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Hailuo 2.3 コア機能',

        // より精密な動的制御と現実的なビジュアル
        dynamicControlTitle: 'より精密な動的制御と現実的なビジュアル',
        dynamicControlDescription:
            'モデルの物理的パフォーマンスと指示に従う能力が大幅に強化され、より複雑で滑らかで自然なキャラクターの身体の動きを生成します。さまざまな大きな動的カメラの動きの下で、照明、明暗の遷移、色調が実写に近い視覚効果を実現し、より高い安定性と精度を実現します。',

        // より強力な多様なスタイル化サポート
        styleSupportTitle: 'より強力な多様なスタイル化サポート',
        styleSupportDescription:
            'アニメ、イラスト、水墨画、ゲームCGなどの特別なアートスタイルのサポートが向上。汎用モデルまたは特定のスタイルを使用する場合でも、出力結果はより安定して生き生きとし、芸術的な創造性を最大限に発揮します。',

        // より繊細な顔の微表情パフォーマンス
        microExpressionTitle: 'より繊細な顔の微表情パフォーマンス',
        microExpressionDescription:
            'Hailuo 2.3では、実在の人物の顔のパフォーマンスと微表情の変化がより自然で繊細になります。AIを通じて微妙な表情の変化を捉えることで、より感染力のあるストーリー性のあるキャラクターのパフォーマンスを作成し、デジタルキャラクターを生き生きとさせます。',

        // 優れた物体の動作指令への応答
        objectMotionTitle: '優れた物体の動作指令への応答',
        objectMotionDescription:
            'Eコマース広告シナリオに特化して最適化され、製品の動作指令への優れた応答を実現。製品の移動と表示の課題を効率的に解決し、Eコマース動画広告の「ドロー率」の成功とプロフェッショナリズムを効果的に向上させます。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        step1Title: 'Hailuo 2.3モデルを選択',
        step1Description:
            '<span class="highlight-text">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Hailuo 2.3」をクリックします。',
        step2Title: '創造的なコンテンツを入力',
        step2Description:
            '生成したい内容を記述するか、変換用の画像をアップロードし、好きなスタイルと効果を選択します。',
        step3Title: '動画をダウンロード',
        step3Description:
            '「作成」をクリックして、生成された最適化された動画を自由にダウンロードまたは共有します。',

        // YouTube動画部分
        youtubeTitle: 'Hailuo 2.3 ビデオモデル関連のYouTube動画',

        // X投稿部分
        xPostsTitle: 'Hailuo 2.3 ビデオモデルに関する人気のX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他のビデオモデルを探索',
        hailuo02Title: 'Hailuo 02 AI動画ジェネレーター',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',
        wanTitle: 'Wan AI動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',
        faq1Question:
            'Hailuo 2.3は以前のバージョンと比較して主な改善点は何ですか？',
        faq1Answer:
            'Hailuo 2.3は4つの主要な領域で改善を達成：より複雑で滑らかな身体の動き、より広範で優れたスタイル化サポート、より繊細で自然な顔の微表情、より精密な物体の動作指令への応答。これらの改善により、生成された動画はより動的に表現力豊かで、よりリアルで安定したビジュアルを実現します。',

        faq2Question:
            'Hailuo 2.3はどのようなタイプの動画作成に適していますか？',
        faq2Answer:
            'ショート動画コンテンツ、Eコマース製品広告、アニメ制作、ゲームCG、芸術的スタイル化されたショートフィルムなどの作成に非常に適しています。特に、製品の動きやキャラクターの表情を正確に制御する必要があるEコマースやコンテンツ制作の分野で優れたパフォーマンスを発揮します。',

        faq3Question:
            'Hailuo 2.3 Fastモデルとは何ですか？標準版との違いは何ですか？',
        faq3Answer:
            'Hailuo 2.3 Fastは生成速度を最適化したモデルバージョンで、価格が低く、速度が速く、大量の動画を生成する必要があり、コストに敏感なユーザー向けに設計されています。標準版は、究極の画質と詳細の点でより優れている可能性があります。ユーザーはプロジェクトのニーズに基づいて柔軟に選択できます。',

        faq4Question:
            'Hailuo 2.3モデルを使用するにはどうすればよいですか？ダウンロードが必要ですか？',
        faq4Answer:
            'ダウンロードは不要です。Hailuo AI公式ウェブサイトに直接アクセスし、WebまたはアプリでHailuo 2.3モデルを選択して動画生成を行うことができます。オープンプラットフォームの開発者は、APIインターフェースを呼び出すことでこの機能を統合することもできます。',

        faq5Question: '新規ユーザーは無料トライアルの機会がありますか？',
        faq5Answer:
            'はい！モデルリリース期間中、すべてのユーザーに毎日無料トライアルクレジットを提供しています。公式ウェブサイトに直接アクセスしてアカウントを登録し、支払いなしでHailuo 2.3の強力な機能をすぐに体験できます。',

        faq6Question: 'Media Agentとは何ですか？Hailuo 2.3との関係は何ですか？',
        faq6Answer:
            'Media Agentは、フルモーダル作成をサポートするAIツールで、Hailuo 2.3などのモデルをインテリジェントに呼び出すことができます。アイデアを入力するだけで、「ワンクリック動画完成」を実現し、動画編集を自動化し、作成プロセスを大幅に簡素化します。それらは互いに補完し合います。',

        faq7Question: 'Hailuo 2.3の動画生成コストは高いですか？',
        faq7Answer:
            'Hailuo 2.3は「業界最高のコストパフォーマンス」を目指しており、効果を向上させながら元の価格を維持しています。さらに、Hailuo 2.3 Fastモデルを選択することで、バッチ作成のコストをさらに大幅に削減できます。',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription:
            '今すぐHailuo 2.3を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでHailuo 2.3を試す',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Hailuo 2.3 비디오 생성기 - MiniMax AI 비디오 제작 플랫폼',
        pageDescription:
            'Hailuo 2.3 비디오 생성기를 체험하세요. 복잡한 신체 움직임, 다양한 스타일화, 얼굴 미세 표정, 물체 동작 명령 응답에서 획기적인 성과를 달성. 전자상거래 광고 시나리오에 최적화. 차세대 AI 비디오 제작 도구를 무료로 체험하세요.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI 비디오 생성기, 전자상거래 비디오, 제품 쇼케이스, 동적 비디오, 무료 AI 비디오, 微鲤AI',

        // 생성기 부분
        generatorTitle: 'Hailuo 2.3 비디오 생성기',
        generatorDescription:
            'MiniMax Hailuo 2.3은 Hailuo 02 모델을 기반으로 한 혁신적인 업그레이드로, <span class="text-text-active">복잡한 신체 움직임, 다양한 스타일화, 얼굴 미세 표정</span> 및 <span class="text-text-active">물체 동작 명령 응답</span>에서 중요한 돌파구를 달성했습니다. 전자상거래 광고와 같은 상업적 시나리오에서 제품의 동적 표시 문제를 해결하는 데 탁월하며, 비디오 콘텐츠 품질과 생산 효율성을 크게 향상시킵니다. <span class="text-text-active">지금 무료로 체험하고</span> 차세대 AI 비디오 제작의 강력한 매력을 경험하세요!',

        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Hailuo 2.3 핵심 기능',

        // 더 정밀한 동적 제어와 현실적인 비주얼
        dynamicControlTitle: '더 정밀한 동적 제어와 현실적인 비주얼',
        dynamicControlDescription:
            '모델의 물리적 성능과 지시 따르기 능력이 크게 향상되어 더 복잡하고 부드럽고 자연스러운 캐릭터 신체 움직임을 생성합니다. 다양한 대형 동적 카메라 움직임 아래에서 조명, 밝기 전환 및 색조가 실제에 가까운 시각 효과를 달성하여 더 높은 안정성과 정확성을 실현합니다.',

        // 더 강력한 다양한 스타일화 지원
        styleSupportTitle: '더 강력한 다양한 스타일화 지원',
        styleSupportDescription:
            '애니메이션, 일러스트레이션, 수묵화, 게임 CG 등의 특별한 아트 스타일에 대한 지원이 향상되었습니다. 범용 모델 또는 특정 스타일을 사용하든 출력 결과가 더 안정적이고 생동감 있으며, 예술적 창의성을 최대한 발휘합니다.',

        // 더 섬세한 얼굴 미세 표정 연기
        microExpressionTitle: '더 섬세한 얼굴 미세 표정 연기',
        microExpressionDescription:
            'Hailuo 2.3에서는 실제 사람의 얼굴 연기와 미세 표정 변화가 더 자연스럽고 섬세합니다. AI를 통해 미묘한 표정 변화를 포착하여 더 감염력 있고 스토리성 있는 캐릭터 연기를 만들어 디지털 캐릭터를 생생하게 만듭니다.',

        // 우수한 물체 동작 명령 응답
        objectMotionTitle: '우수한 물체 동작 명령 응답',
        objectMotionDescription:
            '전자상거래 광고 시나리오에 특화되어 최적화되었으며, 제품의 동작 명령에 대한 우수한 응답을 실현합니다. 제품 이동 및 표시 문제를 효율적으로 해결하고, 전자상거래 비디오 광고의 "추첨율" 성공과 전문성을 효과적으로 향상시킵니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        step1Title: 'Hailuo 2.3 모델 선택',
        step1Description:
            '<span class="highlight-text">「AI 비디오 생성」</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 「Hailuo 2.3」을 클릭합니다.',
        step2Title: '창의적인 콘텐츠 입력',
        step2Description:
            '생성하려는 내용을 설명하거나 변환용 이미지를 업로드하고 선호하는 스타일과 효과를 선택합니다.',
        step3Title: '비디오 다운로드',
        step3Description:
            '「생성」을 클릭하여 생성된 최적화된 비디오를 자유롭게 다운로드하거나 공유합니다.',

        // YouTube 비디오 부분
        youtubeTitle: 'Hailuo 2.3 비디오 모델 관련 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Hailuo 2.3 비디오 모델에 관한 인기 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        hailuo02Title: 'Hailuo 02 AI 비디오 생성기',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        wanTitle: 'Wan AI 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',
        faq1Question:
            'Hailuo 2.3은 이전 버전과 비교하여 주요 개선 사항은 무엇인가요?',
        faq1Answer:
            'Hailuo 2.3은 4가지 주요 영역에서 개선을 달성합니다: 더 복잡하고 부드러운 신체 움직임, 더 광범위하고 우수한 스타일화 지원, 더 섬세하고 자연스러운 얼굴 미세 표정, 더 정밀한 물체 동작 명령에 대한 응답. 이러한 개선으로 생성된 비디오는 더 동적으로 표현력이 풍부하며 더 현실적이고 안정적인 비주얼을 실현합니다.',

        faq2Question: 'Hailuo 2.3은 어떤 유형의 비디오 제작에 적합한가요?',
        faq2Answer:
            '짧은 비디오 콘텐츠, 전자상거래 제품 광고, 애니메이션 제작, 게임 CG, 예술적 스타일화된 단편 영화 등의 제작에 매우 적합합니다. 특히 제품의 움직임이나 캐릭터의 표정을 정확하게 제어해야 하는 전자상거래 및 콘텐츠 제작 분야에서 우수한 성능을 발휘합니다.',

        faq3Question:
            'Hailuo 2.3 Fast 모델은 무엇인가요? 표준 버전과의 차이점은 무엇인가요?',
        faq3Answer:
            'Hailuo 2.3 Fast는 생성 속도를 최적화한 모델 버전으로, 가격이 낮고 속도가 빠르며, 대량의 비디오를 생성해야 하고 비용에 민감한 사용자를 위해 설계되었습니다. 표준 버전은 극한의 화질과 세부 사항에서 더 우수할 수 있습니다. 사용자는 프로젝트 요구 사항에 따라 유연하게 선택할 수 있습니다.',

        faq4Question:
            'Hailuo 2.3 모델을 사용하려면 어떻게 해야 하나요? 다운로드가 필요한가요?',
        faq4Answer:
            '다운로드가 필요하지 않습니다. Hailuo AI 공식 웹사이트에 직접 접속하여 웹 또는 앱에서 Hailuo 2.3 모델을 선택하여 비디오 생성을 수행할 수 있습니다. 오픈 플랫폼 개발자는 API 인터페이스를 호출하여 이 기능을 통합할 수도 있습니다.',

        faq5Question: '신규 사용자는 무료 체험 기회가 있나요?',
        faq5Answer:
            '네! 모델 출시 기간 동안 모든 사용자에게 매일 무료 체험 크레딧을 제공합니다. 공식 웹사이트에 직접 접속하여 계정을 등록하고 결제 없이 Hailuo 2.3의 강력한 기능을 즉시 체험할 수 있습니다.',

        faq6Question:
            'Media Agent는 무엇인가요? Hailuo 2.3과의 관계는 무엇인가요?',
        faq6Answer:
            'Media Agent는 풀 모달 생성을 지원하는 AI 도구로, Hailuo 2.3 등의 모델을 지능적으로 호출할 수 있습니다. 아이디어를 입력하기만 하면 "원클릭 비디오 완성"을 실현하고, 비디오 편집을 자동화하여 생성 프로세스를 크게 간소화합니다. 그들은 서로 보완합니다.',

        faq7Question: 'Hailuo 2.3의 비디오 생성 비용이 높나요?',
        faq7Answer:
            'Hailuo 2.3은 "업계 최고의 비용 효율성"을 목표로 하며, 효과를 향상시키면서 원래 가격을 유지합니다. 또한 Hailuo 2.3 Fast 모델을 선택하면 배치 생성 비용을 더욱 대폭 절감할 수 있습니다.',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 Hailuo 2.3을 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Hailuo 2.3 체험하기',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Hailuo 2.3 视频生成器 - MiniMax AI视频创作平台',
        pageDescription:
            '体验 Hailuo 2.3 视频生成器，在复杂肢体动作、多元风格化、人物微表情以及物体运动指令响应方面实现了关键性突破，专为电商广告等商业场景优化。免费试用下一代AI视频创作工具。',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI视频生成器, 电商视频, 产品展示, 动态视频, 免费AI视频, 微鲤AI',

        // 生成器部分
        generatorTitle: 'Hailuo 2.3 视频生成器',
        generatorDescription:
            'MiniMax Hailuo 2.3 是基于 Hailuo 02 模型的革命性升级，在<span class="text-text-active">复杂肢体动作、多元风格化、人物微表情</span>以及<span class="text-text-active">物体运动指令响应</span>方面实现了关键性突破，尤其擅长解决电商广告等商业场景中的产品动态展示难题，显著提升视频内容的质量与产出效率。立即<span class="text-text-active">免费试用</span>，体验下一代AI视频创作的强大魅力！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo 2.3 核心功能',

        // 更精准的动态控制与真实画面
        dynamicControlTitle: '更精准的动态控制与真实画面',
        dynamicControlDescription:
            '模型对物理表现与指令遵循能力显著增强，可生成更加复杂、流畅且自然的人物肢体动作。在不同的大动态运镜下，光线、明暗过渡和色调都能实现近乎实拍的视觉效果，画面稳定性和精确度更高。',

        // 更强大的多元风格化支持
        styleSupportTitle: '更强大的多元风格化支持',
        styleSupportDescription:
            '对动漫、插画、水墨、游戏CG等特殊画风的支持效果更佳。无论是通用模型还是特定风格，输出效果都更稳定、更生动，充分释放您的艺术创作潜力。',

        // 更细腻的人物微表情演绎
        microExpressionTitle: '更细腻的人物微表情演绎',
        microExpressionDescription:
            '在Hailuo 2.3中，真人面部表演和微表情变化更加自然细腻。通过AI捕捉细微的表情变化，打造更具感染力和故事性的角色表演，让角色物栩栩如生。',

        // 更出色的物体运动指令响应
        objectMotionTitle: '更出色的物体运动指令响应',
        objectMotionDescription:
            '专为电商广告场景优化，对产品的运动指令响应更加出色。可高效解决产品移动、展示等难题，有效提升电商视频广告的"抽卡"成功率和专业度。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择Hailuo 2.3模型',
        step1Description:
            '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo 2.3"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: 'Hailuo 2.3 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Hailuo 2.3 视频模型的 X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他视频模型',
        hailuo02Title: 'Hailuo 02 AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',
        wanTitle: 'Wan AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Hailuo 2.3 相比之前的版本有哪些主要提升？',
        faq1Answer:
            'Hailuo 2.3 主要在四大方面实现提升：肢体动作更复杂流畅、风格化支持更广更佳、人物微表情更细腻自然、对物体运动指令的响应更精准。这些提升共同使得生成的视频动态表现力更强，画面更真实稳定。',

        faq2Question: 'Hailuo 2.3 适合用来制作什么类型的视频？',
        faq2Answer:
            '它非常适合制作短视频内容、电商产品广告、动漫创作、游戏CG、艺术风格化短片等。特别是在需要精确控制产品运动或人物表情的电商和内容创作领域，表现出色。',

        faq3Question: '什么是 Hailuo 2.3 Fast 模型？它和标准版有什么区别？',
        faq3Answer:
            'Hailuo 2.3 Fast 是一个优化了生成速度的模型版本，定价更低，速度更快，专为需要大批量生成视频、对成本敏感的用户设计。标准版则在极限画质和细节上可能更优。用户可根据项目需求灵活选择。',

        faq4Question: '如何使用 Hailuo 2.3 模型？是否需要下载？',
        faq4Answer:
            '无需下载。您可以直接访问海螺AI官网，在网页端或APP中即可选择使用Hailuo 2.3模型进行视频生成。开放平台开发者也可通过调用API接口集成该能力。',

        faq5Question: '新用户是否有免费试用的机会？',
        faq5Answer:
            '是的！在模型发布期间，我们每日为所有用户提供免费试用额度，您可以直接访问官网注册账号，无需付费即可立即体验Hailuo 2.3的强大功能。',

        faq6Question: '什么是 Media Agent？它和 Hailuo 2.3 有什么关系？',
        faq6Answer:
            'Media Agent（媒体智能体）是一个支持全模态创作的AI工具，它可以智能调用Hailuo 2.3等模型。您只需输入想法，它即可实现"一键成片"，自动化完成视频剪辑，极大简化创作流程。它们是相辅相成的关系。',

        faq7Question: 'Hailuo 2.3 的视频生成成本高吗？',
        faq7Answer:
            'Hailuo 2.3 以"业界最优性价比"为目标，在提升效果的同时保持了原有价格。此外，通过选择Hailuo 2.3 Fast模型，还能进一步大幅降低批量创作的成本。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle:
            'Generador de Video Hailuo 2.3 - Plataforma de Creación de Video IA MiniMax',
        pageDescription:
            'Experimenta el generador de video Hailuo 2.3 con avances revolucionarios en movimientos corporales complejos, estilización diversa, microexpresiones faciales y respuesta a comandos de movimiento de objetos. Optimizado para escenarios de publicidad de comercio electrónico. Prueba gratis la herramienta de creación de video IA de próxima generación.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, generador de video IA, video de comercio electrónico, exhibición de productos, video dinámico, video IA gratis, 微鲤AI',

        // Sección del generador
        generatorTitle: 'Generador de Video Hailuo 2.3',
        generatorDescription:
            'MiniMax Hailuo 2.3 es una actualización revolucionaria basada en el modelo Hailuo 02, logrando avances clave en <span class="text-text-active">movimientos corporales complejos, estilización diversa, microexpresiones faciales</span> y <span class="text-text-active">respuesta a comandos de movimiento de objetos</span>. Sobresale en resolver desafíos de exhibición dinámica de productos en escenarios comerciales como la publicidad de comercio electrónico, mejorando significativamente la calidad del contenido de video y la eficiencia de producción. <span class="text-text-active">Pruébalo gratis ahora</span> y experimenta el poderoso encanto de la creación de video IA de próxima generación!',

        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Hailuo 2.3',

        // Control dinámico más preciso y visuales realistas
        dynamicControlTitle:
            'Control Dinámico Más Preciso y Visuales Realistas',
        dynamicControlDescription:
            'El rendimiento físico del modelo y las capacidades de seguimiento de instrucciones están significativamente mejoradas, generando movimientos corporales de personajes más complejos, suaves y naturales. Bajo diferentes movimientos de cámara dinámicos grandes, la iluminación, las transiciones de brillo y los tonos de color pueden lograr efectos visuales casi reales con mayor estabilidad y precisión.',

        // Soporte de estilización diversa más fuerte
        styleSupportTitle: 'Soporte de Estilización Diversa Más Fuerte',
        styleSupportDescription:
            'Mejor soporte para estilos de arte especiales como anime, ilustración, pintura de tinta y CG de videojuegos. Ya sea usando modelos generales o estilos específicos, los resultados de salida son más estables y vívidos, liberando completamente tu potencial creativo artístico.',

        // Interpretación de microexpresiones faciales más delicada
        microExpressionTitle:
            'Interpretación de Microexpresiones Faciales Más Delicada',
        microExpressionDescription:
            'En Hailuo 2.3, las interpretaciones faciales de personas reales y los cambios de microexpresiones son más naturales y delicados. Al capturar cambios sutiles de expresión a través de IA, crea interpretaciones de personajes más infecciosas e impulsadas por historias, haciendo que los personajes digitales cobren vida.',

        // Respuesta superior a comandos de movimiento de objetos
        objectMotionTitle:
            'Respuesta Superior a Comandos de Movimiento de Objetos',
        objectMotionDescription:
            'Optimizado específicamente para escenarios de publicidad de comercio electrónico, con excelente respuesta a comandos de movimiento de productos. Resuelve eficientemente desafíos en el movimiento y exhibición de productos, mejorando efectivamente la tasa de éxito y el profesionalismo de la publicidad de video de comercio electrónico.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Hailuo 2.3',
        step1Description:
            'Ve a la página de <span class="highlight-text">"Generación de Video IA"</span>, luego haz clic en "Hailuo 2.3" en el menú desplegable de modelos.',
        step2Title: 'Ingresa Tu Contenido Creativo',
        step2Description:
            'Describe lo que deseas generar, o carga imágenes para conversión, y elige tus estilos y efectos preferidos.',
        step3Title: 'Descarga Tu Video',
        step3Description:
            'Haz clic en "Crear" para descargar o compartir el video optimizado generado.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Video Hailuo 2.3',

        // Sección de publicaciones de X
        xPostsTitle:
            'Publicaciones Populares de X sobre el Modelo de Video Hailuo 2.3',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        hailuo02Title: 'Generador de Video IA Hailuo 02',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        wanTitle: 'Generador de Video IA Wan',

        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas Frecuentes',
        faq1Question:
            '¿Cuáles son las principales mejoras de Hailuo 2.3 en comparación con versiones anteriores?',
        faq1Answer:
            'Hailuo 2.3 logra mejoras en cuatro áreas principales: movimientos corporales más complejos y suaves, soporte de estilización más amplio y mejor, microexpresiones faciales más delicadas y naturales, y respuesta más precisa a comandos de movimiento de objetos. Estas mejoras juntas hacen que los videos generados sean más expresivos dinámicamente con visuales más realistas y estables.',

        faq2Question: '¿Para qué tipos de videos es adecuado crear Hailuo 2.3?',
        faq2Answer:
            'Es muy adecuado para crear contenido de video corto, anuncios de productos de comercio electrónico, creación de anime, CG de videojuegos, cortometrajes estilizados artísticos, etc. Funciona particularmente bien en campos de comercio electrónico y creación de contenido que requieren control preciso del movimiento del producto o las expresiones de los personajes.',

        faq3Question:
            '¿Qué es el modelo Hailuo 2.3 Fast? ¿Cuál es la diferencia con la versión estándar?',
        faq3Answer:
            'Hailuo 2.3 Fast es una versión del modelo optimizada para velocidad de generación, con precios más bajos y velocidad más rápida, diseñada para usuarios que necesitan generar videos en grandes lotes y son sensibles a los costos. La versión estándar puede ser mejor en términos de calidad de imagen definitiva y detalle. Los usuarios pueden elegir flexiblemente según las necesidades del proyecto.',

        faq4Question: '¿Cómo usar el modelo Hailuo 2.3? ¿Necesito descargarlo?',
        faq4Answer:
            'No se requiere descarga. Puedes visitar directamente el sitio web oficial de Hailuo AI y seleccionar el modelo Hailuo 2.3 para la generación de video en la web o en la aplicación. Los desarrolladores de plataforma abierta también pueden integrar esta capacidad llamando a la interfaz API.',

        faq5Question:
            '¿Los nuevos usuarios tienen oportunidad de prueba gratuita?',
        faq5Answer:
            '¡Sí! Durante el período de lanzamiento del modelo, proporcionamos créditos de prueba gratuitos a todos los usuarios diariamente. Puedes visitar directamente el sitio web oficial para registrar una cuenta y experimentar inmediatamente las poderosas funciones de Hailuo 2.3 sin pago.',

        faq6Question:
            '¿Qué es Media Agent? ¿Cuál es su relación con Hailuo 2.3?',
        faq6Answer:
            'Media Agent es una herramienta de IA que admite la creación de modalidad completa y puede llamar inteligentemente a modelos como Hailuo 2.3. Solo necesitas ingresar tus ideas, y puede lograr la "finalización de video con un clic", completando automáticamente la edición de video y simplificando enormemente el proceso de creación. Se complementan entre sí.',

        faq7Question: '¿Es alto el costo de generación de video de Hailuo 2.3?',
        faq7Answer:
            'Hailuo 2.3 apunta a la "mejor relación costo-efectividad de la industria", manteniendo el precio original mientras mejora los efectos. Además, al elegir el modelo Hailuo 2.3 Fast, puedes reducir aún más significativamente el costo de la creación por lotes.',

        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription:
            'Experimenta Hailuo 2.3 ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Hailuo 2.3 en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Tu navegador no admite la reproducción de video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle:
            'Générateur Vidéo Hailuo 2.3 - Plateforme de Création Vidéo IA MiniMax',
        pageDescription:
            "Découvrez le générateur vidéo Hailuo 2.3 avec des avancées révolutionnaires dans les mouvements corporels complexes, la stylisation diverse, les micro-expressions faciales et la réponse aux commandes de mouvement d'objets. Optimisé pour les scénarios publicitaires de commerce électronique. Essayez gratuitement l'outil de création vidéo IA de nouvelle génération.",
        pageKeywords:
            'Hailuo 2.3, MiniMax, générateur vidéo IA, vidéo e-commerce, vitrine de produits, vidéo dynamique, vidéo IA gratuite, 微鲤AI',

        // Section générateur
        generatorTitle: 'Générateur Vidéo Hailuo 2.3',
        generatorDescription:
            'MiniMax Hailuo 2.3 est une mise à niveau révolutionnaire basée sur le modèle Hailuo 02, réalisant des percées clés dans <span class="text-text-active">les mouvements corporels complexes, la stylisation diverse, les micro-expressions faciales</span> et <span class="text-text-active">la réponse aux commandes de mouvement d\'objets</span>. Il excelle à résoudre les défis d\'affichage dynamique de produits dans des scénarios commerciaux tels que la publicité de commerce électronique, améliorant considérablement la qualité du contenu vidéo et l\'efficacité de production. <span class="text-text-active">Essayez-le gratuitement maintenant</span> et découvrez le charme puissant de la création vidéo IA de nouvelle génération!',

        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Hailuo 2.3',

        dynamicControlTitle:
            'Contrôle Dynamique Plus Précis et Visuels Réalistes',
        dynamicControlDescription:
            "Les performances physiques du modèle et les capacités de suivi des instructions sont considérablement améliorées, générant des mouvements corporels de personnages plus complexes, fluides et naturels. Sous différents grands mouvements de caméra dynamiques, l'éclairage, les transitions de luminosité et les tons de couleur peuvent obtenir des effets visuels presque réels avec une plus grande stabilité et précision.",

        styleSupportTitle: 'Support de Stylisation Diverse Plus Fort',
        styleSupportDescription:
            "Meilleur support pour les styles artistiques spéciaux tels que l'anime, l'illustration, la peinture à l'encre et le CG de jeux vidéo. Que vous utilisiez des modèles généraux ou des styles spécifiques, les résultats de sortie sont plus stables et vivants, libérant complètement votre potentiel créatif artistique.",

        microExpressionTitle:
            'Interprétation de Micro-expressions Faciales Plus Délicate',
        microExpressionDescription:
            "Dans Hailuo 2.3, les performances faciales de personnes réelles et les changements de micro-expressions sont plus naturels et délicats. En capturant les changements d'expression subtils grâce à l'IA, il crée des performances de personnages plus contagieuses et axées sur l'histoire, donnant vie aux personnages numériques.",

        objectMotionTitle:
            "Réponse Supérieure aux Commandes de Mouvement d'Objets",
        objectMotionDescription:
            "Optimisé spécifiquement pour les scénarios publicitaires de commerce électronique, avec une excellente réponse aux commandes de mouvement de produits. Il résout efficacement les défis du mouvement et de l'affichage des produits, améliorant efficacement le taux de réussite et le professionnalisme de la publicité vidéo de commerce électronique.",

        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Hailuo 2.3',
        step1Description:
            'Accédez à la page <span class="highlight-text">"Génération de Vidéo IA"</span>, puis cliquez sur "Hailuo 2.3" dans le menu déroulant des modèles.',
        step2Title: 'Saisissez Votre Contenu Créatif',
        step2Description:
            'Décrivez ce que vous souhaitez générer, ou téléchargez des images pour conversion, et choisissez vos styles et effets préférés.',
        step3Title: 'Téléchargez Votre Vidéo',
        step3Description:
            'Cliquez sur "Créer" pour télécharger ou partager la vidéo optimisée générée.',

        youtubeTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 2.3',
        xPostsTitle: 'Publications X Populaires sur le Modèle Vidéo Hailuo 2.3',

        exploreModelsTitle: "Explorer D'autres Modèles",
        hailuo02Title: 'Générateur Vidéo IA Hailuo 02',
        sora2Title: 'Générateur Vidéo IA OpenAI Sora-2',
        wanTitle: 'Générateur Vidéo IA Wan',

        faqTitle: 'Questions Fréquemment Posées',
        faq1Question:
            'Quelles sont les principales améliorations de Hailuo 2.3 par rapport aux versions précédentes?',
        faq1Answer:
            "Hailuo 2.3 réalise des améliorations dans quatre domaines principaux: mouvements corporels plus complexes et fluides, support de stylisation plus large et meilleur, micro-expressions faciales plus délicates et naturelles, et réponse plus précise aux commandes de mouvement d'objets.",

        faq2Question: 'Pour quels types de vidéos Hailuo 2.3 est-il adapté?',
        faq2Answer:
            "Il est très adapté pour créer du contenu vidéo court, des publicités de produits e-commerce, de la création d'anime, du CG de jeux vidéo, des courts métrages stylisés artistiques, etc.",

        faq3Question:
            "Qu'est-ce que le modèle Hailuo 2.3 Fast? Quelle est la différence avec la version standard?",
        faq3Answer:
            'Hailuo 2.3 Fast est une version du modèle optimisée pour la vitesse de génération, avec un prix inférieur et une vitesse plus rapide, conçue pour les utilisateurs qui ont besoin de générer des vidéos en grande quantité.',

        faq4Question:
            'Comment utiliser le modèle Hailuo 2.3? Dois-je le télécharger?',
        faq4Answer:
            "Aucun téléchargement requis. Vous pouvez directement visiter le site officiel de Hailuo AI et sélectionner le modèle Hailuo 2.3 pour la génération vidéo sur le web ou dans l'application.",

        faq5Question:
            "Les nouveaux utilisateurs ont-ils l'opportunité d'essai gratuit?",
        faq5Answer:
            "Oui! Pendant la période de lancement du modèle, nous fournissons quotidiennement des crédits d'essai gratuits à tous les utilisateurs.",

        faq6Question:
            "Qu'est-ce que Media Agent? Quelle est sa relation avec Hailuo 2.3?",
        faq6Answer:
            "Media Agent est un outil d'IA qui prend en charge la création de modalité complète et peut appeler intelligemment des modèles tels que Hailuo 2.3.",

        faq7Question: 'Le coût de génération vidéo de Hailuo 2.3 est-il élevé?',
        faq7Answer:
            'Hailuo 2.3 vise le "meilleur rapport coût-efficacité de l\'industrie", maintenant le prix d\'origine tout en améliorant les effets.',

        ctaTitle: 'Prêt à Commencer à Créer?',
        ctaDescription:
            'Découvrez Hailuo 2.3 maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Hailuo 2.3 sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',

        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax KI-Video-Erstellungsplattform',
        pageDescription:
            'Erleben Sie den Hailuo 2.3 Video Generator mit revolutionären Durchbrüchen bei komplexen Körperbewegungen, vielfältiger Stilisierung, Gesichtsmikroausdrücken und Objektbewegungsbefehlsantwort.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, KI-Video-Generator, E-Commerce-Video, Produktpräsentation, dynamisches Video, kostenloses KI-Video, 微鲤AI',

        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 ist ein revolutionäres Upgrade basierend auf dem Hailuo 02 Modell mit wichtigen Durchbrüchen bei <span class="text-text-active">komplexen Körperbewegungen, vielfältiger Stilisierung, Gesichtsmikroausdrücken</span> und <span class="text-text-active">Objektbewegungsbefehlsantwort</span>.',

        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        coreFeaturesTitle: 'Hailuo 2.3 Hauptfunktionen',
        dynamicControlTitle:
            'Präzisere Dynamische Steuerung und Realistische Visuals',
        dynamicControlDescription:
            'Die physikalische Leistung und die Anweisungsbefolgungsfähigkeiten des Modells sind erheblich verbessert.',
        styleSupportTitle: 'Stärkere Diverse Stilisierungsunterstützung',
        styleSupportDescription:
            'Bessere Unterstützung für spezielle Kunststile wie Anime, Illustration, Tuschemalerei und Videospiel-CG.',
        microExpressionTitle: 'Feinere Gesichtsmikroausdrucks-Interpretation',
        microExpressionDescription:
            'In Hailuo 2.3 sind echte Gesichtsdarstellungen und Mikroausdrucksänderungen natürlicher und feiner.',
        objectMotionTitle: 'Überlegene Objektbewegungsbefehlsantwort',
        objectMotionDescription:
            'Speziell für E-Commerce-Werbeszenarien optimiert, mit hervorragender Antwort auf Produktbewegungsbefehle.',

        howToUseTitle: 'Wie zu Verwenden',
        step1Title: 'Hailuo 2.3 Modell Auswählen',
        step1Description:
            'Gehen Sie zur Seite <span class="highlight-text">"KI-Videogenerierung"</span> und klicken Sie dann im Modell-Dropdown-Menü auf "Hailuo 2.3".',
        step2Title: 'Geben Sie Ihren Kreativen Inhalt Ein',
        step2Description:
            'Beschreiben Sie, was Sie generieren möchten, oder laden Sie Bilder zur Konvertierung hoch.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description:
            'Klicken Sie auf "Erstellen", um das generierte optimierte Video herunterzuladen oder zu teilen.',

        youtubeTitle: 'YouTube-Videos über das Hailuo 2.3 Videomodell',
        xPostsTitle: 'Beliebte X-Beiträge über das Hailuo 2.3 Videomodell',

        exploreModelsTitle: 'Andere Modelle Erkunden',
        hailuo02Title: 'Hailuo 02 KI-Video-Generator',
        sora2Title: 'OpenAI Sora-2 KI-Video-Generator',
        wanTitle: 'Wan KI-Video-Generator',

        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question:
            'Was sind die Hauptverbesserungen von Hailuo 2.3 im Vergleich zu früheren Versionen?',
        faq1Answer:
            'Hailuo 2.3 erzielt Verbesserungen in vier Hauptbereichen: komplexere und flüssigere Körperbewegungen, breitere und bessere Stilisierungsunterstützung.',
        faq2Question: 'Für welche Arten von Videos ist Hailuo 2.3 geeignet?',
        faq2Answer:
            'Es eignet sich sehr gut für die Erstellung von Kurzvideoinhalten, E-Commerce-Produktwerbung, Anime-Erstellung, Videospiel-CG usw.',
        faq3Question: 'Was ist das Hailuo 2.3 Fast Modell?',
        faq3Answer:
            'Hailuo 2.3 Fast ist eine für Generierungsgeschwindigkeit optimierte Modellversion mit niedrigeren Preisen und schnellerer Geschwindigkeit.',
        faq4Question: 'Wie verwendet man das Hailuo 2.3 Modell?',
        faq4Answer:
            'Kein Download erforderlich. Sie können direkt die offizielle Hailuo AI Website besuchen.',
        faq5Question: 'Haben neue Benutzer eine kostenlose Testmöglichkeit?',
        faq5Answer:
            'Ja! Während der Modellveröffentlichungszeit bieten wir allen Benutzern täglich kostenlose Testguthaben.',
        faq6Question: 'Was ist Media Agent?',
        faq6Answer:
            'Media Agent ist ein KI-Tool, das die vollständige Modalitätserstellung unterstützt.',
        faq7Question: 'Sind die Videogenerierungskosten von Hailuo 2.3 hoch?',
        faq7Answer:
            'Hailuo 2.3 zielt auf das "beste Preis-Leistungs-Verhältnis der Branche" ab.',

        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription:
            'Erleben Sie Hailuo 2.3 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Probieren Sie Hailuo 2.3 auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        videoNotSupported: 'Ihr Browser unterstützt die Videowiedergabe nicht',
        videoLoadError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
    },
    ru: {
        pageTitle:
            'Генератор Видео Hailuo 2.3 - Платформа Создания ИИ-Видео MiniMax',
        pageDescription:
            'Испытайте генератор видео Hailuo 2.3 с революционными достижениями в сложных движениях тела, разнообразной стилизации, микровыражениях лица и ответе на команды движения объектов.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, генератор ИИ-видео, видео электронной коммерции, демонстрация продукта, динамическое видео, бесплатное ИИ-видео, 微鲤AI',

        generatorTitle: 'Генератор Видео Hailuo 2.3',
        generatorDescription:
            'MiniMax Hailuo 2.3 - это революционное обновление на основе модели Hailuo 02, достигающее ключевых прорывов в <span class="text-text-active">сложных движениях тела, разнообразной стилизации, микровыражениях лица</span> и <span class="text-text-active">ответе на команды движения объектов</span>.',

        tabImageToVideo: 'Изображение в Видео',
        tabTextToVideo: 'Текст в Видео',

        coreFeaturesTitle: 'Основные Функции Hailuo 2.3',
        dynamicControlTitle:
            'Более Точный Динамический Контроль и Реалистичные Визуализации',
        dynamicControlDescription:
            'Физические характеристики модели и возможности следования инструкциям значительно улучшены.',
        styleSupportTitle: 'Более Сильная Поддержка Разнообразной Стилизации',
        styleSupportDescription:
            'Лучшая поддержка специальных художественных стилей, таких как аниме, иллюстрация, чернильная живопись и игровой CG.',
        microExpressionTitle: 'Более Тонкая Интерпретация Микровыражений Лица',
        microExpressionDescription:
            'В Hailuo 2.3 выступления реальных лиц и изменения микровыражений более естественны и тонки.',
        objectMotionTitle: 'Превосходный Ответ на Команды Движения Объектов',
        objectMotionDescription:
            'Специально оптимизирован для сценариев рекламы электронной коммерции.',

        howToUseTitle: 'Как Использовать',
        step1Title: 'Выберите Модель Hailuo 2.3',
        step1Description:
            'Перейдите на страницу <span class="highlight-text">"Генерация ИИ-Видео"</span>, затем нажмите "Hailuo 2.3" в выпадающем меню моделей.',
        step2Title: 'Введите Ваш Творческий Контент',
        step2Description:
            'Опишите, что вы хотите сгенерировать, или загрузите изображения для преобразования.',
        step3Title: 'Скачайте Ваше Видео',
        step3Description:
            'Нажмите "Создать", чтобы загрузить или поделиться сгенерированным оптимизированным видео.',

        youtubeTitle: 'Видео YouTube о Видеомодели Hailuo 2.3',
        xPostsTitle: 'Популярные Публикации X о Видеомодели Hailuo 2.3',

        exploreModelsTitle: 'Исследовать Другие Модели',
        hailuo02Title: 'Генератор ИИ-Видео Hailuo 02',
        sora2Title: 'Генератор ИИ-Видео OpenAI Sora-2',
        wanTitle: 'Генератор ИИ-Видео Wan',

        faqTitle: 'Часто Задаваемые Вопросы',
        faq1Question:
            'Каковы основные улучшения Hailuo 2.3 по сравнению с предыдущими версиями?',
        faq1Answer:
            'Hailuo 2.3 достигает улучшений в четырех основных областях.',
        faq2Question: 'Для каких типов видео подходит Hailuo 2.3?',
        faq2Answer:
            'Он очень подходит для создания короткого видеоконтента, рекламы продуктов электронной коммерции.',
        faq3Question: 'Что такое модель Hailuo 2.3 Fast?',
        faq3Answer:
            'Hailuo 2.3 Fast - это версия модели, оптимизированная для скорости генерации.',
        faq4Question: 'Как использовать модель Hailuo 2.3?',
        faq4Answer:
            'Загрузка не требуется. Вы можете напрямую посетить официальный сайт Hailuo AI.',
        faq5Question:
            'Есть ли у новых пользователей возможность бесплатной пробной версии?',
        faq5Answer:
            'Да! В период выпуска модели мы предоставляем бесплатные пробные кредиты всем пользователям ежедневно.',
        faq6Question: 'Что такое Media Agent?',
        faq6Answer:
            'Media Agent - это инструмент ИИ, который поддерживает полномодальное создание.',
        faq7Question: 'Высока ли стоимость генерации видео Hailuo 2.3?',
        faq7Answer:
            'Hailuo 2.3 нацелен на "лучшую в отрасли экономическую эффективность".',

        ctaTitle: 'Готовы Начать Создавать?',
        ctaDescription:
            'Испытайте Hailuo 2.3 сейчас и превратите свое творчество в удивительные видео',
        ctaButton: 'Попробуйте Hailuo 2.3 на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',

        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        pageTitle:
            'Gerador de Vídeo Hailuo 2.3 - Plataforma de Criação de Vídeo IA MiniMax',
        pageDescription:
            'Experimente o gerador de vídeo Hailuo 2.3 com conquistas revolucionárias em movimentos corporais complexos, estilização diversa, micro-expressões faciais e resposta a comandos de movimento de objetos.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, gerador de vídeo IA, vídeo de e-commerce, vitrine de produtos, vídeo dinâmico, vídeo IA grátis, 微鲤AI',

        generatorTitle: 'Gerador de Vídeo Hailuo 2.3',
        generatorDescription:
            'MiniMax Hailuo 2.3 é uma atualização revolucionária baseada no modelo Hailuo 02, alcançando avanços importantes em <span class="text-text-active">movimentos corporais complexos, estilização diversa, micro-expressões faciais</span> e <span class="text-text-active">resposta a comandos de movimento de objetos</span>.',

        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        coreFeaturesTitle: 'Recursos Principais do Hailuo 2.3',
        dynamicControlTitle:
            'Controle Dinâmico Mais Preciso e Visuais Realistas',
        dynamicControlDescription:
            'O desempenho físico do modelo e as capacidades de seguir instruções são significativamente aprimoradas.',
        styleSupportTitle: 'Suporte de Estilização Diversa Mais Forte',
        styleSupportDescription:
            'Melhor suporte para estilos artísticos especiais como anime, ilustração, pintura a tinta e CG de jogos.',
        microExpressionTitle:
            'Interpretação de Micro-expressões Faciais Mais Delicada',
        microExpressionDescription:
            'No Hailuo 2.3, as performances faciais de pessoas reais e mudanças de micro-expressões são mais naturais e delicadas.',
        objectMotionTitle:
            'Resposta Superior a Comandos de Movimento de Objetos',
        objectMotionDescription:
            'Otimizado especificamente para cenários de publicidade de e-commerce.',

        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Hailuo 2.3',
        step1Description:
            'Vá para a página <span class="highlight-text">"Geração de Vídeo IA"</span>, depois clique em "Hailuo 2.3" no menu suspenso de modelos.',
        step2Title: 'Insira Seu Conteúdo Criativo',
        step2Description:
            'Descreva o que você deseja gerar ou carregue imagens para conversão.',
        step3Title: 'Baixe Seu Vídeo',
        step3Description:
            'Clique em "Criar" para baixar ou compartilhar o vídeo otimizado gerado.',

        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo Hailuo 2.3',
        xPostsTitle:
            'Publicações X Populares sobre o Modelo de Vídeo Hailuo 2.3',

        exploreModelsTitle: 'Explorar Outros Modelos',
        hailuo02Title: 'Gerador de Vídeo IA Hailuo 02',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        wanTitle: 'Gerador de Vídeo IA Wan',

        faqTitle: 'Perguntas Frequentes',
        faq1Question:
            'Quais são as principais melhorias do Hailuo 2.3 em comparação com versões anteriores?',
        faq1Answer:
            'O Hailuo 2.3 alcança melhorias em quatro áreas principais.',
        faq2Question: 'Para quais tipos de vídeos o Hailuo 2.3 é adequado?',
        faq2Answer:
            'É muito adequado para criar conteúdo de vídeo curto, anúncios de produtos de e-commerce.',
        faq3Question: 'O que é o modelo Hailuo 2.3 Fast?',
        faq3Answer:
            'Hailuo 2.3 Fast é uma versão do modelo otimizada para velocidade de geração.',
        faq4Question: 'Como usar o modelo Hailuo 2.3?',
        faq4Answer:
            'Não é necessário download. Você pode visitar diretamente o site oficial do Hailuo AI.',
        faq5Question: 'Os novos usuários têm oportunidade de teste gratuito?',
        faq5Answer:
            'Sim! Durante o período de lançamento do modelo, fornecemos créditos de teste gratuitos a todos os usuários diariamente.',
        faq6Question: 'O que é o Media Agent?',
        faq6Answer:
            'Media Agent é uma ferramenta de IA que suporta criação de modalidade completa.',
        faq7Question: 'O custo de geração de vídeo do Hailuo 2.3 é alto?',
        faq7Answer:
            'O Hailuo 2.3 visa o "melhor custo-benefício da indústria".',

        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription:
            'Experimente o Hailuo 2.3 agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente Hailuo 2.3 no 微鲤AI',
        ctaDisclaimer: 'Nenhum cartão de crédito necessário',

        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        pageTitle:
            'Generatore Video Hailuo 2.3 - Piattaforma di Creazione Video IA MiniMax',
        pageDescription:
            'Sperimenta il generatore video Hailuo 2.3 con conquiste rivoluzionarie nei movimenti corporei complessi, stilizzazione diversificata, micro-espressioni facciali e risposta ai comandi di movimento degli oggetti.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, generatore video IA, video e-commerce, vetrina prodotti, video dinamico, video IA gratuito, 微鲤AI',

        generatorTitle: 'Generatore Video Hailuo 2.3',
        generatorDescription:
            'MiniMax Hailuo 2.3 è un aggiornamento rivoluzionario basato sul modello Hailuo 02, ottenendo progressi chiave nei <span class="text-text-active">movimenti corporei complessi, stilizzazione diversificata, micro-espressioni facciali</span> e <span class="text-text-active">risposta ai comandi di movimento degli oggetti</span>.',

        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        coreFeaturesTitle: 'Funzionalità Principali di Hailuo 2.3',
        dynamicControlTitle:
            'Controllo Dinamico Più Preciso e Visual Realistici',
        dynamicControlDescription:
            'Le prestazioni fisiche del modello e le capacità di seguire le istruzioni sono significativamente migliorate.',
        styleSupportTitle: 'Supporto di Stilizzazione Diversificata Più Forte',
        styleSupportDescription:
            'Migliore supporto per stili artistici speciali come anime, illustrazione, pittura a inchiostro e CG di videogiochi.',
        microExpressionTitle:
            'Interpretazione di Micro-espressioni Facciali Più Delicata',
        microExpressionDescription:
            'In Hailuo 2.3, le performance facciali di persone reali e i cambiamenti di micro-espressioni sono più naturali e delicati.',
        objectMotionTitle:
            'Risposta Superiore ai Comandi di Movimento degli Oggetti',
        objectMotionDescription:
            'Ottimizzato specificamente per scenari pubblicitari di e-commerce.',

        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona Modello Hailuo 2.3',
        step1Description:
            'Vai alla pagina <span class="highlight-text">"Generazione Video IA"</span>, quindi fai clic su "Hailuo 2.3" nel menu a discesa dei modelli.',
        step2Title: 'Inserisci il Tuo Contenuto Creativo',
        step2Description:
            'Descrivi cosa vuoi generare o carica immagini per la conversione.',
        step3Title: 'Scarica il Tuo Video',
        step3Description:
            'Fai clic su "Crea" per scaricare o condividere il video ottimizzato generato.',

        youtubeTitle: 'Video YouTube sul Modello Video Hailuo 2.3',
        xPostsTitle: 'Post X Popolari sul Modello Video Hailuo 2.3',

        exploreModelsTitle: 'Esplora Altri Modelli',
        hailuo02Title: 'Generatore Video IA Hailuo 02',
        sora2Title: 'Generatore Video IA OpenAI Sora-2',
        wanTitle: 'Generatore Video IA Wan',

        faqTitle: 'Domande Frequenti',
        faq1Question:
            'Quali sono i principali miglioramenti di Hailuo 2.3 rispetto alle versioni precedenti?',
        faq1Answer:
            'Hailuo 2.3 ottiene miglioramenti in quattro aree principali.',
        faq2Question: 'Per quali tipi di video è adatto Hailuo 2.3?',
        faq2Answer:
            'È molto adatto per creare contenuti video brevi, pubblicità di prodotti e-commerce.',
        faq3Question: "Cos'è il modello Hailuo 2.3 Fast?",
        faq3Answer:
            'Hailuo 2.3 Fast è una versione del modello ottimizzata per la velocità di generazione.',
        faq4Question: 'Come usare il modello Hailuo 2.3?',
        faq4Answer:
            'Nessun download richiesto. Puoi visitare direttamente il sito ufficiale di Hailuo AI.',
        faq5Question: "I nuovi utenti hanno l'opportunità di prova gratuita?",
        faq5Answer:
            'Sì! Durante il periodo di lancio del modello, forniamo crediti di prova gratuiti a tutti gli utenti quotidianamente.',
        faq6Question: "Cos'è Media Agent?",
        faq6Answer:
            'Media Agent è uno strumento IA che supporta la creazione di modalità completa.',
        faq7Question: 'Il costo di generazione video di Hailuo 2.3 è alto?',
        faq7Answer:
            'Hailuo 2.3 punta al "miglior rapporto costo-efficacia del settore".',

        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription:
            'Sperimenta Hailuo 2.3 ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Hailuo 2.3 su 微鲤AI',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',

        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadError: 'Impossibile caricare il video',
        videoReload: 'Ricarica',
    },
    ar: {
        pageTitle:
            'مولد فيديو Hailuo 2.3 - منصة إنشاء فيديو بالذكاء الاصطناعي MiniMax',
        pageDescription:
            'جرب مولد فيديو Hailuo 2.3 مع إنجازات ثورية في حركات الجسم المعقدة والتصميم المتنوع وتعبيرات الوجه الدقيقة واستجابة أوامر حركة الأشياء.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, مولد فيديو بالذكاء الاصطناعي, فيديو التجارة الإلكترونية, عرض المنتجات, فيديو ديناميكي, فيديو ذكاء اصطناعي مجاني, 微鲤AI',

        generatorTitle: 'مولد فيديو Hailuo 2.3',
        generatorDescription:
            'MiniMax Hailuo 2.3 هو ترقية ثورية تستند إلى نموذج Hailuo 02، محققًا اختراقات رئيسية في <span class="text-text-active">حركات الجسم المعقدة والتصميم المتنوع وتعبيرات الوجه الدقيقة</span> و<span class="text-text-active">استجابة أوامر حركة الأشياء</span>.',

        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        coreFeaturesTitle: 'الميزات الأساسية لـ Hailuo 2.3',
        dynamicControlTitle: 'تحكم ديناميكي أكثر دقة ومرئيات واقعية',
        dynamicControlDescription:
            'تم تحسين الأداء الفيزيائي للنموذج وقدرات اتباع التعليمات بشكل كبير.',
        styleSupportTitle: 'دعم تصميم متنوع أقوى',
        styleSupportDescription:
            'دعم أفضل للأنماط الفنية الخاصة مثل الأنيمي والتوضيح والرسم بالحبر وCG ألعاب الفيديو.',
        microExpressionTitle: 'تفسير أكثر دقة لتعبيرات الوجه الدقيقة',
        microExpressionDescription:
            'في Hailuo 2.3، تكون عروض الوجه الحقيقية وتغيرات التعبيرات الدقيقة أكثر طبيعية ودقة.',
        objectMotionTitle: 'استجابة متفوقة لأوامر حركة الأشياء',
        objectMotionDescription:
            'محسّن خصيصًا لسيناريوهات إعلانات التجارة الإلكترونية.',

        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'حدد نموذج Hailuo 2.3',
        step1Description:
            'انتقل إلى صفحة <span class="highlight-text">"توليد فيديو بالذكاء الاصطناعي"</span>، ثم انقر على "Hailuo 2.3" في القائمة المنسدلة للنماذج.',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description: 'صف ما تريد توليده أو قم بتحميل الصور للتحويل.',
        step3Title: 'قم بتنزيل الفيديو الخاص بك',
        step3Description:
            'انقر على "إنشاء" لتنزيل أو مشاركة الفيديو المحسّن المولد.',

        youtubeTitle: 'فيديوهات YouTube حول نموذج الفيديو Hailuo 2.3',
        xPostsTitle: 'منشورات X الشائعة حول نموذج الفيديو Hailuo 2.3',

        exploreModelsTitle: 'استكشف نماذج أخرى',
        hailuo02Title: 'مولد فيديو بالذكاء الاصطناعي Hailuo 02',
        sora2Title: 'مولد فيديو بالذكاء الاصطناعي OpenAI Sora-2',
        wanTitle: 'مولد فيديو بالذكاء الاصطناعي Wan',

        faqTitle: 'الأسئلة الشائعة',
        faq1Question:
            'ما هي التحسينات الرئيسية لـ Hailuo 2.3 مقارنة بالإصدارات السابقة؟',
        faq1Answer: 'يحقق Hailuo 2.3 تحسينات في أربعة مجالات رئيسية.',
        faq2Question: 'لأي أنواع من الفيديوهات يناسب Hailuo 2.3؟',
        faq2Answer:
            'إنه مناسب جدًا لإنشاء محتوى فيديو قصير وإعلانات منتجات التجارة الإلكترونية.',
        faq3Question: 'ما هو نموذج Hailuo 2.3 Fast؟',
        faq3Answer: 'Hailuo 2.3 Fast هو إصدار نموذج محسّن لسرعة التوليد.',
        faq4Question: 'كيف أستخدم نموذج Hailuo 2.3؟',
        faq4Answer:
            'لا حاجة للتنزيل. يمكنك زيارة الموقع الرسمي لـ Hailuo AI مباشرة.',
        faq5Question: 'هل لدى المستخدمين الجدد فرصة للتجربة المجانية؟',
        faq5Answer:
            'نعم! خلال فترة إطلاق النموذج، نوفر أرصدة تجريبية مجانية لجميع المستخدمين يوميًا.',
        faq6Question: 'ما هو Media Agent؟',
        faq6Answer:
            'Media Agent هو أداة ذكاء اصطناعي تدعم الإنشاء الكامل للوسائط.',
        faq7Question: 'هل تكلفة توليد فيديو Hailuo 2.3 عالية؟',
        faq7Answer:
            'يهدف Hailuo 2.3 إلى "أفضل فعالية من حيث التكلفة في الصناعة".',

        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription:
            'جرب Hailuo 2.3 الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Hailuo 2.3 على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',

        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: { // Thai (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    da: { // Danish (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    no: { // Norwegian (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    nl: { // Dutch (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    id: { // Indonesian (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    tr: { // Turkish (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            'What are the main improvements of Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 achieves improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more delicate and natural facial micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamically expressive with more realistic and stable visuals.',

        faq2Question:
            'What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',

        faq3Question:
            'What is the Hailuo 2.3 Fast model? What is the difference from the standard version?',
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed for users who need to generate videos in large batches and are cost-sensitive. The standard version may be better in terms of ultimate image quality and detail. Users can flexibly choose based on project needs.',

        faq4Question:
            'How to use the Hailuo 2.3 model? Do I need to download it?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the app. Open platform developers can also integrate this capability by calling the API interface.',

        faq5Question: 'Do new users have a free trial opportunity?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits to all users daily. You can directly visit the official website to register an account and immediately experience the powerful functions of Hailuo 2.3 without payment.',

        faq6Question:
            'What is Media Agent? What is its relationship with Hailuo 2.3?',
        faq6Answer:
            'Media Agent is an AI tool that supports full-modal creation and can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video completion", automatically completing video editing and greatly simplifying the creation process. They complement each other.',

        faq7Question: 'Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-best cost-effectiveness", maintaining the original pricing while improving effects. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
}
